const accept = '.pdf,.png';
const accept2 = '.pdf,.png';
const rootURL='https://eic.blueballon.cn/api/v1.0';
// const rootURL='http://192.168.1.104:3000/api/v1.0';
const uploadURL=rootURL+'/upload/';

export default {
    accept,accept2,rootURL,uploadURL
}